var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulbFill = function SvgBulbFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bulb_fill_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bulb_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5a2.84 2.84 0 0 1-2.5-1.438 2.407 2.407 0 0 1-1.766-.734A2.407 2.407 0 0 1 10 23.563v-4.438c-1.23-.813-2.214-1.885-2.953-3.219a8.808 8.808 0 0 1-1.11-4.344c0-2.52.88-4.661 2.641-6.421C10.338 3.38 12.48 2.5 15 2.5c2.52 0 4.662.88 6.422 2.64 1.76 1.761 2.64 3.902 2.64 6.423 0 1.604-.37 3.062-1.109 4.374A9.135 9.135 0 0 1 20 19.125v4.438c0 .687-.245 1.276-.734 1.765-.49.49-1.078.735-1.766.735A2.84 2.84 0 0 1 15 27.5Zm-2.5-3.938h5v-1.125h-5v1.125Zm0-2.375h5V20h-5v1.188Zm3.438-3.687v-3.375l2.093-2.094a.899.899 0 0 0 .282-.656.899.899 0 0 0-.282-.656.899.899 0 0 0-.656-.281.899.899 0 0 0-.656.28L15 12.439l-1.719-1.72a.899.899 0 0 0-.656-.28.899.899 0 0 0-.656.28.9.9 0 0 0-.281.657.9.9 0 0 0 .28.656l2.095 2.094V17.5h1.874Z",
    fill: "#5E53FB"
  }))));
};
export default SvgBulbFill;